import _ from 'lodash'
import { dataNodes } from '@wix/thunderbolt-catharsis'
import { DataNodeAdapter } from './compNodeAdapter'
import { shapeIdsDataNodes } from '@wix/thunderbolt-fetch-shapes'

export function getDataNodes() {
	return _.mapValues({ ...dataNodes, ...shapeIdsDataNodes }, (dataNode) => DataNodeAdapter(dataNode))
}
